exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i);", ""]);

// module
exports.push([module.id, ".home__title {\n  font-size: 28px;\n  text-transform: capitalize;\n  text-align: center;\n  letter-spacing: 9px;\n  margin-bottom: 30px; }\n  @media only screen and (max-width: 568px) {\n    .home__title {\n      font-size: 24px; } }\n\n.home__search {\n  width: 100%;\n  max-width: 460px;\n  margin: auto; }\n\n.home__button {\n  display: flex;\n  justify-content: inherit;\n  align-items: center;\n  flex-wrap: wrap;\n  flex-direction: column;\n  text-align: center;\n  margin-top: 30px; }\n  .home__button:before, .home__button:after {\n    position: relative;\n    content: '';\n    width: 2px;\n    height: 40px;\n    display: block;\n    background: #ededed; }\n  .home__button .button {\n    width: 150px;\n    font-size: 12px;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    margin: 20px 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/containers/Home/Home.scss
// module id = 398
// module chunks = 0